import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {withRouter} from 'react-router-dom';
import {
    addPopup,
    removePopup,
    showFirstLoginPopup,
    setUserData,
    setUserRequestDone
} from "../../../redux/actions";
import {useRegisterMutation, useGenerateOtpMutation, useEditUserInformationMutation} from "../../../redux/api/users.api";
import AnalyticsManager from '../../../app/analytics';
import Validate from 'app/validation/validation';
import {executeWithCaptcha} from "../../../app/functions";
import store from '../../../redux';
import './index.scss';

import * as popups from '../../../constants/popup-types';

//components
import AnimatedInput from "../../../components/forms/animated_input";
import Checkbox from "../../../components/forms/checkbox";
import AutoComplete from "../../../components/forms/autocomplete";
import CustomDatePicker from "../../shared/date_picker/date_picker";

//assets
import cb_checked_mobile from 'assets/icons/checkbox-checked-purple-mobile.svg';
import cb_checked from 'assets/icons/checkbox-check-purple.svg';
import cb from 'assets/icons/checkbox-purple.svg';
import female from 'assets/icons/radio-female.svg';
import male from 'assets/icons/radio-male.svg';
import radio_empty from 'assets/icons/radio-thin-empty.svg';
import radio_checked from 'assets/icons/radio-checked.svg';
import { getMediaPath, reactParserCommonOptions } from '../../../app/functions';
import Recaptcha from "../../../components/services/google/recaptcha";
import ReactHtmlParser from 'react-html-parser';
import HtmlCheckbox from "../../../components/forms/htmlCheckbox";
import { RECAPTCHA_ACTIONS } from 'components/services/google/recaptcha';
import { OTP_PROCESS } from 'pages/personal-zone/utils/enums';
const RegistrationForm = (props) => {
    const dispatch = useDispatch();
    const [registerMutation] = useRegisterMutation();
    const [generateOtpMutation] = useGenerateOtpMutation();
    const [editUserInformation] = useEditUserInformationMutation();
    
    const deviceState = useSelector((state) => state.state.deviceState);
    const text = useSelector((state) => state.config.Translations);
    const citiesArr = useSelector((state) => state.config.citiesArr);
    const work_places = useSelector((state) => state.config.WorkPlaces);
    const userData = useSelector((state) => state.config.UserData);
    const firstLogin = useSelector((state) => state.config.FirstLoginReturn);
    const dataSharing = useSelector((state) => state.config.dataSharingConfig);

    const [disabled, setDisabled] = useState(true);
    const [first_try, setFirst_try] = useState(true);
    const [form, setForm] = useState({
        email: {
            val: '',
            valid: false,
            rules: ['email', 'not_empty'],
            errMsg: '',
        },
        first_name: {
            val: '',
            valid: false,
            rules: ['not_empty', 'first_name'],
            errMsg: '',
        },
        last_name: {
            val: '',
            valid: false,
            rules: ['not_empty', 'last_name'],
            errMsg: '',
        },
        phone: {
            val: '',
            valid: false,
            rules: ['phone', 'not_empty'],
            errMsg: '',
        }
    });
    const [data_sharing_consent, setData_sharing_consent] = useState(false);
    const [request_data_sharing_consent, setRequest_data_sharing_consent] = useState(false);
    const [policy_check, setPolicy_check] = useState(false);
    const [business, setBusiness] = useState({
        errMsg: '',
        selected: -1,
        valid: false,
        query: '',
    });
    const [city, setCity] = useState({
        errMsg: '',
        selected: -1,
        valid: false,
        query: '',
    });
    const [gender, setGender] = useState(0);
    const [birth_day, setBirth_day] = useState(0);
    const [isClickedSubmit, setIsClickedSubmit] = useState(false);
    const [marketing_consent, setMarketing_consent] = useState(false);
    const [is_show_marketing_checkbox, setIs_show_marketing_checkbox] = useState(false);
    const [is_clicked_terms, setIs_clicked_terms] = useState(false);
    const [is_clicked_privacy_policy, setIs_clicked_privacy_policy] = useState(false);
    const latestPayloadRef = useRef(null);

    useEffect(() => {
        const existingDataSharingAgreement = firstLogin?.dataSharingAgreement ?? false;
        const existingMarketingAgreement = firstLogin?.isMarketingApproved ?? false;

        if (userData || firstLogin.userData) {
            const user = userData || firstLogin.userData;
            const policyCheck = userData !== false;

            setGender(parseInt(user.gender));
            setPolicy_check(policyCheck);
            setCity(prev => ({...prev, selected: user.cityId}));
            setBusiness(prev => ({...prev, selected: user.workPlaceId}));
            setForm(prev => ({
                ...prev,
                phone: {...prev.phone, val: user.phone},
                email: {...prev.email, val: user.email},
                first_name: {...prev.first_name, val: user.first_name},
                last_name: {...prev.last_name, val: user.last_name}
            }));
            setBirth_day(user.birthday * 1000);
        } else {
            console.log('No user data found - this appears to be a new registration');
        }

        setData_sharing_consent(existingDataSharingAgreement);
        setMarketing_consent(existingMarketingAgreement);
        setRequest_data_sharing_consent(!existingDataSharingAgreement);
        setIs_show_marketing_checkbox(!existingMarketingAgreement);
        setIs_clicked_terms(false);
        setIs_clicked_privacy_policy(false);
    }, [firstLogin, userData]);

    const otpEventHandler = useCallback(async (data) => {
        AnalyticsManager.logEditUserInformation();

        try {
            const payloadToUse = data || latestPayloadRef.current;
            if (!payloadToUse) {
                console.error('No payload data available for edit user information');
                return;
            }

            const sessionToken = store.getState().tokens.sessionToken;
            if (sessionToken) {
                payloadToUse['sessionToken'] = sessionToken;
            }
            
            const result = await editUserInformation(payloadToUse).unwrap();

            if (!result) {
                return;
            }
            dispatch(setUserData(result));
            
            AnalyticsManager.updateUserProperties(result);
            AnalyticsManager.logRegister(result);
            
            dispatch(setUserRequestDone(true));
            
            dispatch(removePopup());
            
            setTimeout(() => {
                dispatch(addPopup({
                    type: popups.GENERAL_MESSAGE,
                    text: 'פרטייך נשמרו בהצלחה',
                }));
            }, 100);
        } catch (error) {
            console.error('Failed to update user information:', error);
        }
    }, [dispatch, editUserInformation]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const hasUserData = userData || firstLogin?.userData;
        
        
        setIsClickedSubmit(true);

        const submit = !hasUserData || !disabled;
        
        if (submit) {
            const user = hasUserData;
            
            let form_valid = true;
            let new_form = {...form};

            for (let field in form) {
                let validate = Validate(form[field].val, form[field].rules);
                let is_valid = validate.valid;
                let msg = validate.msg;

                new_form[field].valid = is_valid;
                new_form[field].errMsg = msg;

                if (is_valid === false) {
                    form_valid = false;
                }
            }

            setForm(new_form);
            setFirst_try(false);

            if (form_valid && policy_check && gender !== 0) {
                let payload = {};
                
                executeWithCaptcha(async (token) => {
                    for (let key in form) {
                        payload[key] = form[key].val;
                    }
                    setDisabled(true);
                    payload['workPlaceId'] = business.selected;
                    payload['cityId'] = city.selected;
                    payload['gender'] = gender;
                    payload['birthDate'] = birth_day / 1000;
                    payload['userId'] = firstLogin.id;
                    payload['policy_check'] = policy_check;
                    payload['data_sharing_consent'] = data_sharing_consent;
                    payload['g-recaptcha-response'] = token;
                    payload['marketing_consent'] = marketing_consent;
                    payload['is_first_login'] = 'true';
                    if (user) {
                        
                        dispatch(showFirstLoginPopup(false));
                        payload['userId'] = user.user_id;
                        let isChange = false;

                        //Checking all fields if any changes were made
                        if (user.phone !== form.phone.val) {
                            isChange = true;
                        }
                        if (user.email !== form.email.val) {
                            isChange = true;
                        }
                        if (user.first_name !== form.first_name.val) {
                            isChange = true;
                        }
                        if (user.last_name !== form.last_name.val) {
                            isChange = true;
                        }
                        if (user.cityId !== city.selected) {
                            isChange = true;
                        }
                        if (user.workPlaceId !== business.selected) {
                            isChange = true;
                        }
                        if (parseInt(user.gender) !== parseInt(gender)) {
                            isChange = true;
                        }
                        if (parseInt(user.birthday || 0) !== parseInt(birth_day / 1000)) {
                            isChange = true;
                        }

                        if (isChange) {
                            const payloadForEdit = {...payload};
                            delete payloadForEdit['g-recaptcha-response'];
                            latestPayloadRef.current = payloadForEdit;
                            
                            dispatch(addPopup({
                                type: popups.PHONE_VALIDATION,
                                phone: form.phone.val,
                                is_first_login: false,
                                data: payload,
                                action: otpEventHandler,
                                process: OTP_PROCESS.VERIFY,
                            }));
                        } else {                                
                            dispatch(addPopup({
                                type: popups.GENERAL_MESSAGE,
                                text: 'פרטייך נשמרו בהצלחה',
                            }));
                        }
                    }
                    //first login form - only generate OTP, don't register yet
                    else {
                        // Generate OTP first, registration will happen after OTP validation
                        const otpPayload = {
                            userId: String(firstLogin.id),
                            cellphone: String(form.phone.val),
                            ccDigits: firstLogin.last4Digits || firstLogin.ccDigits || firstLogin.last_digits,
                            process: 'register'
                        };
                        
                        executeWithCaptcha(async (otpToken) => {
                            otpPayload['g-recaptcha-response'] = otpToken;
                            
                            try {
                                const otpResult = await generateOtpMutation(otpPayload).unwrap();
                                
                                // Create OTP response data with user info and registration payload
                                const otpDataWithUserId = {
                                    ...otpResult,
                                    userId: firstLogin.id,
                                    phone: form.phone.val,
                                    ccDigits: firstLogin.last4Digits || firstLogin.ccDigits || firstLogin.last_digits,
                                    registrationPayload: payload // Store registration data for later use
                                };
                                
                                
                                if (props.setPhone) props.setPhone(form.phone.val);
                                if (props.setUserId) props.setUserId(firstLogin.id);
                                if (props.setEamil) props.setEamil(form.email.val);
                                if (props.setOtpResponseData) {
                                    props.setOtpResponseData(otpDataWithUserId);
                                }
                                dispatch(showFirstLoginPopup(true));
                                if (props.setData) props.setData(payload);
                                if (props.stepUp) props.stepUp({ before: 2, after: 3, processType: 'Register' });
                            } catch (otpError) {
                                console.error('OTP generation failed:', otpError);
                            }
                        }, RECAPTCHA_ACTIONS.VERIFY_CODE);
                    }
                    setDisabled(true);
                });
            }
        } else {
            setDisabled(!disabled);
        }
    };

    const handleInputChange = (e) => {
        const {value, name} = e.target;
        let validate = Validate(value, form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        setForm(prev => ({
            ...prev, 
            [name]: {...prev[name], val: value, valid: is_valid, errMsg: msg}
        }));
    };

    const getAllBusinesses = () => {
        const data = work_places;
        let res = data.map(item => {
            return {text: item?.text, id: item?.id};
        });
        return res;
    };

    const fieldOnSelected = (id, text, field) => {
        if (field === 'business') {
            setBusiness(prev => ({...prev, selected: id, errMsg: '', valid: true, query: text}));
        } else if (field === 'city') {
            setCity(prev => ({...prev, selected: id, errMsg: '', valid: true, query: text}));
        }
    };

    const fieldOnChange = (e, field) => {
        if (field === 'business') {
            setBusiness(prev => ({...prev, query: e.target.value}));
        } else if (field === 'city') {
            setCity(prev => ({...prev, query: e.target.value}));
        }
    };

    const clearFieldAutocomplete = (field) => {
        if (field === 'business') {
            setBusiness(prev => ({...prev, query: '', selected: -1}));
        } else if (field === 'city') {
            setCity(prev => ({...prev, query: '', selected: -1}));
        }
    };

    const getCities = () => {
        const data = citiesArr;
        let res = [];
        for (let key in data) {
            res.push({text: data[key].text, id: data[key].id});
        }
        return res;
    };

    const onIsracardClick = () => {
        const onIsracardConfirm = () => {
            setData_sharing_consent(true);
        };

        dispatch(addPopup({
            type: popups.GENERAL_MESSAGE,
            text: ReactHtmlParser(dataSharing.description_content, reactParserCommonOptions()),
            action: () => onIsracardConfirm(),
            className: 'normal'
        }));
    };

    const isMobileOrTablet = deviceState === 'mobile' || deviceState === 'tablet';

    const showErrorFirstName = !first_try && !form.first_name.valid;
    const showErrorLastName = !first_try && !form.last_name.valid;
    const showErrorEmail = !first_try && !form.email.valid;
    const showErrorPhone = !first_try && !form.phone.valid;
    const showErrorPolicy = isClickedSubmit && !policy_check;

    const showGenderErr = !first_try && gender === 0;

    const hasUserData = userData || firstLogin?.userData;
    const editable = disabled && hasUserData;
    const neededDataShareAgreement = dataSharing && request_data_sharing_consent;
    

    const checkedCheckboxImage = isMobileOrTablet ? getMediaPath(cb_checked_mobile) : getMediaPath(cb_checked);
    const uncheckedCheckboxImage = getMediaPath(cb);

    const {btnText = ''} = props;

    return (
        <div className='registration'>
            <div className='welcome'>
                <span className='welcome-title'>{text['login_title']}</span>
                <span className='welcome-subtitle'>{text['login_subtitle']}</span>
            </div>

            {!isMobileOrTablet && <h2 className='re-title'>{text['personal_details_title']}</h2>}

            <form className={'registration-form ' + (editable ? 'disabled' : '')} onSubmit={handleSubmit}>
                <AnimatedInput className={'field'}
                               value={form.first_name.val}
                               name={'first_name'}
                               placeholder={text['personal_details_firstName']}
                               onChange={e => handleInputChange(e)}
                               showError={showErrorFirstName}
                               errorMessage={form.first_name.errMsg}
                />
                <AnimatedInput className={'field'}
                               value={form.last_name.val}
                               name={'last_name'}
                               placeholder={text['personal_details_lastName']}
                               onChange={e => handleInputChange(e)}
                               showError={showErrorLastName}
                               errorMessage={form.last_name.errMsg}
                />
                <AnimatedInput className={'field'}
                               value={form.email.val}
                               name={'email'}
                               placeholder={text['personal_details_email']}
                               onChange={e => handleInputChange(e)}
                               showError={showErrorEmail}
                               errorMessage={form.email.errMsg}
                />
                <AnimatedInput className={'field'}
                               value={form.phone.val}
                               name={'phone'}
                               placeholder={text['personal_details_phone']}
                               onChange={e => handleInputChange(e)}
                               showError={showErrorPhone}
                               errorMessage={form.phone.errMsg}
                               type={'number'}
                />

                <div className='AutoComplete-wrap'>
                    <AutoComplete className={'auto-field business'}
                                  placeholder={text['personal_details_workPlace']}
                                  options={getAllBusinesses()}
                                  query={business.query}
                                  onSelect={(id, text) => fieldOnSelected(id, text, 'business')}
                                  sortByDefault={false}
                                  onChange={(e) => fieldOnChange(e, 'business')}
                                  onClear={() => clearFieldAutocomplete('business')}
                                  selected_id={business.selected}
                    />
                    <span>{business.errMsg}</span>
                </div>

                <div className='AutoComplete-wrap'>
                    <AutoComplete className={'auto-field'}
                                  placeholder={text['personal_details_city']}
                                  options={getCities()}
                                  query={city.query}
                                  onSelect={(id, text) => fieldOnSelected(id, text, 'city')}
                                  sortByDefault={false}
                                  onChange={(e) => fieldOnChange(e, 'city')}
                                  onClear={() => clearFieldAutocomplete('city')}
                                  selected_id={city.selected}
                    />
                    <span>{city.errMsg}</span>
                </div>

                <div className='date-wrapper'>
                    <span className='date-placeholder'>{text['registration_form_placeholder']}</span>
                    <CustomDatePicker className={'hot-date-picker'}
                                      onChange={(date) => setBirth_day(date)}/>
                </div>
                <div className='radio-group'>
                    {showGenderErr &&
                    <span className='gender-err-msg'>{text['registration_form_gender_err_msg']}</span>}
                    <span className='label'>{text['personal_details_radio_label']}</span>
                    <div className='choice-wrap' onClick={() => setGender(1)}>
                        <img className='radio'
                             src={gender === 1 ? getMediaPath(radio_checked) : getMediaPath(radio_empty)}
                             alt='/'/>
                        <img src={getMediaPath(female)} alt='/'/>
                    </div>
                    <div className='choice-wrap' onClick={() => setGender(2)}>
                        <img className='radio'
                             src={gender === 2 ? getMediaPath(radio_checked) : getMediaPath(radio_empty)}
                             alt='/'/>
                        <img className='radio-male' src={getMediaPath(male)} alt='/'/>
                    </div>
                </div>

                {!userData && (
                    <div className="checkboxes-container">
                        <HtmlCheckbox
                            name="policy"
                            html={text['register_details_screen_terms_checkbox_html_web']}
                            onChange={(state) => setPolicy_check(state)}
                            checked_img={checkedCheckboxImage}
                            not_checked_img={uncheckedCheckboxImage}
                            className="policy-cb"
                        />

                        {showErrorPolicy && (
                            <p className="checkbox-error">
                                {text['personal_details_policy_err']}
                            </p>
                        )}

                        {is_show_marketing_checkbox && (
                            <HtmlCheckbox
                                name="marketing-agreement"
                                html={text['marketing_consent_text']}
                                value={marketing_consent}
                                onChange={(state) => setMarketing_consent(state)}
                                checked_img={checkedCheckboxImage}
                                not_checked_img={uncheckedCheckboxImage}
                                className="data-sharing-cb"
                            />
                        )}

                        {neededDataShareAgreement && (
                            <HtmlCheckbox
                                name="data-share-agreement"
                                html={text['agreement_content_register']}
                                value={data_sharing_consent}
                                onChange={(state) => setData_sharing_consent(state)}
                                checked_img={checkedCheckboxImage}
                                onAllLinksClicked={() => onIsracardClick()}
                                not_checked_img={uncheckedCheckboxImage}
                                className="data-sharing-cb"
                            />
                        )}
                    </div>
                )}

                <button type="submit" className="submit-btn">
                    {(disabled && hasUserData) ? text['registration_update'] : btnText}
                </button>

                <Recaptcha isFunction={true} enterprise={true} onReady={() => {}}/>
            </form>
        </div>
    );
};

export default withRouter(RegistrationForm);
